"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntersectionObserverContext = exports.ResizeObserverContext = exports.MatchMediaContext = void 0;
/* eslint-disable jsdoc/require-jsdoc */
const react_1 = require("react");
// @todo возможно стоит убрать "window." тк наблюдаются проблемы в iOS
exports.MatchMediaContext = (0, react_1.createContext)({
    matchMedia(query) {
        // ВАЖНО: доступ к window.matchMedia должен осуществляться именно в момент вызова а не в момент определения контекста
        // ВАЖНО: используем "window.matchMedia" вместо "matchMedia" тк падают ошибки в некоторых браузерах
        return window.matchMedia(query);
    },
});
exports.ResizeObserverContext = (0, react_1.createContext)({
    createResizeObserver(callback) {
        // ВАЖНО: доступ к window.ResizeObserver должен осуществляться именно в момент вызова а не в момент определения контекста
        return new window.ResizeObserver(callback);
    },
});
exports.IntersectionObserverContext = (0, react_1.createContext)({
    createIntersectionObserver(...args) {
        // ВАЖНО: доступ к window.IntersectionObserver должен осуществляться именно в момент вызова а не в момент определения контекста
        return new window.IntersectionObserver(...args);
    },
});
//# sourceMappingURL=index.js.map